import { csrfToken } from './components/csrf-token';
import { lightbox } from './components/lightbox';
import { carousel } from './components/carousel';

var el = document.querySelector('.mobileTrigger');
var collapse = document.querySelector('.collapse');
var mobileMenu = document.querySelector('.mobileNav');
var mobileMenuA = document.querySelector('.mobileTrigger a');
var gallery = document.querySelector('.gallery');

el.onclick = function() {
    mobileMenu.classList.toggle('active');
    var status = el.getAttribute("aria-expanded"); 
    if ( status == "true")  {
        status = "false"
    } else {
        status = "true"
    }
    el.setAttribute("aria-expanded", status);
    mobileMenuA.setAttribute("aria-expanded", status)
}
collapse.onclick = function() {
    mobileMenu.classList.remove('active');
    el.setAttribute("aria-expanded", false);
    mobileMenuA.setAttribute("aria-expanded", false)
}

if (gallery) { 
    console.log('i see gallery')
    lightbox();
}

csrfToken();
carousel();